import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import draftTypes from 'constants/draftTypes';

import { formatNumberDecimals } from 'utils/formats';

import Radio from 'modules/_shared/components/Radio';
import proportionalityTypes from 'modules/drafts/pages/DraftCapitalIncrease/proportionalityTypes';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';

const ProportionalitySection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddDraftInvestorModal();

  const translationSuffix =
    data.draftType === draftTypes.DRAFT_CAPITAL_INCREASE ? '.FORCED' : '';

  return (
    <div className="form-group">
      <div className="row">
        <div className="col-6">
          <Radio
            id="manual-proportionality-type-radio"
            name="proportionalityType"
            value=""
            label={t('IndicateContribution')}
            checked={data.proportionalityType === ''}
            onChange={actions.handleChangeProportionalityType}
          />
        </div>

        <div className="col-6">
          <Radio
            id="custom-nd-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.CUSTOM_ND}
            label={t(`IndicatePercent${translationSuffix}`, { type: 'ND' })}
            checked={
              data.proportionalityType === proportionalityTypes.CUSTOM_ND
            }
            onChange={actions.handleChangeProportionalityType}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Radio
            id="nd-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.ND}
            label={t('ThePartnerGoesProportionalND', {
              NDPercent: formatNumberDecimals(data.partnerNdPercent),
            })}
            checked={data.proportionalityType === proportionalityTypes.ND}
            onChange={actions.handleChangeProportionalityType}
            disabled={!data.isExistentPartner}
          />
        </div>

        <div className="col-6">
          <Radio
            id="custom-fd-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.CUSTOM_FD}
            label={t(`IndicatePercent${translationSuffix}`, { type: 'FD' })}
            checked={
              data.proportionalityType === proportionalityTypes.CUSTOM_FD
            }
            onChange={actions.handleChangeProportionalityType}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Radio
            id="fd-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.FD}
            label={t('ThePartnerGoesProportionalFD', {
              NDPercent: formatNumberDecimals(data.partnerNdPercent),
            })}
            checked={data.proportionalityType === proportionalityTypes.FD}
            onChange={actions.handleChangeProportionalityType}
            disabled={!data.isExistentPartner}
          />
        </div>

        <div className="col-6">
          <Radio
            id="custom-potential-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.CUSTOM_POTENTIAL}
            label={t(`IndicatePercent${translationSuffix}`, {
              type: 'Potential',
            })}
            checked={
              data.proportionalityType === proportionalityTypes.CUSTOM_POTENTIAL
            }
            onChange={actions.handleChangeProportionalityType}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Radio
            id="potential-proportionality-type-radio"
            name="proportionalityType"
            value={proportionalityTypes.POTENTIAL}
            label={t('ThePartnerGoesProportionalPotential', {
              NDPercent: formatNumberDecimals(data.partnerNdPercent),
            })}
            checked={
              data.proportionalityType === proportionalityTypes.POTENTIAL
            }
            onChange={actions.handleChangeProportionalityType}
            disabled={!data.isExistentPartner}
          />
        </div>
      </div>
    </div>
  );
};

export default ProportionalitySection;
